module.exports = __webpack_public_path__ + "static/media/12.f575d513.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/12.png
// module id = 1294
// module chunks = 0